//#region src/lib/focus.ts
/**
* Spec 204 (Liquid Glass pass) — the one keyboard focus ring for every
* interactive control that is not a field: a 2px `ring` with a 2px offset in
* the page colour, shown only for keyboard focus. Fields keep the DESIGN §7.4
* border affordance instead. Compose with `cn(focusRing, …)`.
*/
const focusRing = "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background";
/**
* Spec 199 §3 — the same ring on a wrapper whose focusable child is hidden:
* a choice card (`RadioCards`) is a `<label>` around a visually hidden native
* radio, so the ring follows the radio's keyboard focus onto the card.
* Literal classes (Tailwind only generates what it reads in source); kept
* equal to `focusRing` by its test.
*/
const focusRingWithin = "has-[:focus-visible]:outline-none has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-ring has-[:focus-visible]:ring-offset-2 has-[:focus-visible]:ring-offset-background";
//#endregion
export { focusRing, focusRingWithin };
